import * as React from "react";

const SvgErrorNoMatchingIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 96" {...props}>
    <path d="M73.199 93.438c-23.977-24.003-48.007-47.954-71.95-71.99-2.724-3.134-.445-7.032 2.273-9.173C7.38 8.517 11.048 4.545 15.027.925c3.308-2.351 6.788.22 8.924 2.787 23.28 23.306 46.613 46.56 69.859 69.899 2.724 3.134.445 7.032-2.273 9.173-3.857 3.758-7.526 7.73-11.504 11.35-2.081 1.42-5.085 1.11-6.834-.696zm-59.024 0c-4.39-4.491-8.997-8.792-13.25-13.405-2.351-3.308.22-6.788 2.787-8.924 23.306-23.28 46.561-46.614 69.9-69.86 3.134-2.724 7.032-.445 9.173 2.273 3.758 3.858 7.73 7.526 11.35 11.505 2.351 3.308-.22 6.788-2.787 8.924-23.306 23.28-46.561 46.614-69.9 69.86-2.067 1.756-5.397 1.579-7.273-.373z" />
    <path
      fill="none"
      stroke="#fff"
      strokeLinejoin="round"
      strokeWidth={0.38}
      d="M-.47-.47h96v96h-96z"
      paintOrder="stroke fill markers"
    />
  </svg>
);

export default SvgErrorNoMatchingIcon;
